import axiosBEInstance from '../utils/axios-backend'
import { faroError, info, warn } from '../utils/logger';
import { LoggerMetaData } from 'interfaces/logger.interface';
import { ApiRequest, StandardApiResponse } from 'interfaces/api-request.interface';
import { API_CANCELLED_TIMEOUT_ERR } from '@constant';
import { AxiosResponse } from 'axios';
import axiosSWBEInstance from '../utils/axios-sw-backend'
export default class HttpBackendService {

    logRequest(apiRequest: ApiRequest, loggerMetaData?: LoggerMetaData){
        const data = {
            ...apiRequest,
            ...loggerMetaData
        }
        info(`Calling|${apiRequest.eventType}`, data, loggerMetaData);
    }

    logResponse(status: number, apiRequest: ApiRequest, response: AxiosResponse, headers:any, loggerMetaData?: LoggerMetaData){
        const data = {
            ...apiRequest,
            ...loggerMetaData,
            code: status,
            response,
            headers,
        }
        if(loggerMetaData) {
            loggerMetaData.spSessionId = response.headers['x-sp-session-id'] || loggerMetaData?.spSessionId;
        }
        if(response.data?.data?.referenceId && loggerMetaData) {
            loggerMetaData.paymentCode = response.data?.data?.referenceId;
        }
        info(`Response|${apiRequest.eventType}`, data, loggerMetaData);
    }

    logResponseError(apiRequest: ApiRequest, code: number, error: any, loggerMetaData?: LoggerMetaData) {
        let errorMessage = `${code}`
    
        if (error.responseData?.message) {
          errorMessage += `|${error.responseData?.message}`
        } else if (typeof error.responseData === 'string') {
          errorMessage += `|${error.responseData}`
        } else if (error.message) {
          errorMessage += `|${error.message}`
        } else if (!error.message && code == 504) {
          errorMessage += '|timeout'
        } else if (!error.message && code == 0) {
          errorMessage += '|unknown'
        }
    
        const message = `Exception after invoking '${apiRequest.eventType}' - ${errorMessage}`
        if (code >= 400 && code < 500) warn(message, error, loggerMetaData)
        else faroError(message, error, loggerMetaData)
    
      }

    async doFetch(apiRequest: ApiRequest, loggerMetaData?: LoggerMetaData): Promise<StandardApiResponse>{
        try {
            this.logRequest(apiRequest, loggerMetaData);
            const response = await axiosBEInstance.request({
                url: apiRequest.endpoint,
                method: apiRequest.method,
                signal: apiRequest.signal,
                params: apiRequest.params,
                data: apiRequest.body
            })
            this.logResponse(response.status, apiRequest, response, response.headers, loggerMetaData)
            return { data: response.data, headers: response.headers }
        } catch (error:any) {
            const status =
                error.code === API_CANCELLED_TIMEOUT_ERR
                ? 504
                : 0
            const code = error.response?.status || status
            const errorData = {
                error,
                code,
                endpoint: apiRequest.endpoint,
                responseData: error.response?.data,
                responseHeaders: error.response?.headers,
                spSessionId: loggerMetaData?.spSessionId,
                message: error.message,
                stack: error.cause
            }
            this.logResponseError(apiRequest, status, errorData, loggerMetaData)
            return { error }
        }
    }

    async doFetchSW(apiRequest: ApiRequest, loggerMetaData?: LoggerMetaData): Promise<StandardApiResponse>{
        try {
            this.logRequest(apiRequest, loggerMetaData);
            const response = await axiosSWBEInstance.request({
                url: apiRequest.endpoint,
                method: apiRequest.method,
                signal: apiRequest.signal,
                params: apiRequest.params,
                data: apiRequest.body
            })
            this.logResponse(response.status, apiRequest, response, response.headers, loggerMetaData)
            return { data: response.data, headers: response.headers }
        } catch (error:any) {
            const status =
                error.code === API_CANCELLED_TIMEOUT_ERR
                ? 504
                : 0
            const code = error.response?.status || status
            const errorData = {
                error,
                code,
                endpoint: apiRequest.endpoint,
                responseData: error.response?.data,
                responseHeaders: error.response?.headers,
                spSessionId: loggerMetaData?.spSessionId,
                message: error.message,
                stack: error.cause
            }
            this.logResponseError(apiRequest, status, errorData, loggerMetaData)
            return { error }
        }
    }
    
}